"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "colorrequestExternalEditCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $filter,
      $localStorage,
      apiSettings,
      MessageService,
      tools,
      ColorRequest,
      Customer,
      WorkflowApproval,
      Internal,
      maxAllowedFileSize,
      customers,
      model,
      attachmentTypes,
      salesList,
      Attachment,
      enumerators
    ) {
      var vm = this;

      var $translate = $filter("translate");


      angular.extend($scope.$parent.vm, {
        title: "colorsRequests.settings.title",
        insertUrl: null,
      });

      vm.enumerators = enumerators;
      vm.projectModule = config.projectModule;

      vm.userId = $localStorage.userId;
      $scope.uploader = {};

      // INICIALIZAÇÕES
      $rootScope.laddaLoading = false;
      vm.model = model;

      vm.attachment = {}; // Inicializa a model que armazena as informações de um novo anexo
      vm.attachmentEditing = {}; // Inicializa a model que armazena as informações do anexo que está sendo editado
      vm.attachmentsInvoiceSaleList =
        attachmentTypes.filter(
          (x) => x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
        ).length > 0
          ? attachmentTypes.filter(
            (x) =>
              x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
          )[0].attachments
          : [];

      vm.attachments = [];
      vm.isAttaching = false;
      vm.isInsertSale = false;
      vm.showSales = false;
      vm.sale = {
        valueTintingProducts: 0,
        valueOthersProducts: 0,
        colorsProducts: [],
        othersProducts: [],
      };
      // CONFIGURAÇÃO DO UPLOAD
      vm.attachmentsInvoiceSale = [];
      vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;

      vm.tempFolder = tools.getRandomString(8);
      vm.uploadConfig = {
        singleFile: true,
        testChunks: false,
        target:
          apiSettings.baseUri +
          "v1/internal/upload" +
          "?tempFolder=" +
          vm.tempFolder,
        headers: {
          Authorization: "Bearer " + $localStorage.authorizationData.token,
        },
      };
      vm.uploadImageConfig = {
        singleFile: true,
        testChunks: false,
        target:
          apiSettings.baseUri +
          "v1/chat/upload-image/" +
          vm.model.colorsRequestId,
        headers: {
          Authorization: "Bearer " + $localStorage.authorizationData.token,
        },
      };
      vm.allowedFileExtensions = [];
      vm.maxAllowedFileSiz = 0;
      vm.customers = customers;

      if (vm.model.customerId && vm.customers && vm.customers.length) {
        vm.selectedCustomer = vm.customers.find(function (item) {
          return item.key == vm.model.customerId;
        })
        vm.model.customerId = null;
      }

      // AUTOCOMPLETE DE Cliente
      vm.getCustomer = function (val) {
        return Customer.listIds({ keyword: val }).$promise;
      };

      // AUTOCOMPLETE DE CORES
      vm.getColors = function (val) {
        return Internal.colorsList({ pageSize: 50, keyword: val }).$promise;
      };

      vm.delColor = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.model.colors.splice(index, 1);
      };

      vm.editAttachment = function (item, enumAttachmentType) {
        vm.showAttachmentForm(true, enumAttachmentType);

        vm.attachmentEditing = item; //Guarda a referência do item que está sendo editado numa variável global, para que a mesma seja atualizada no caso do usuário clicar no botão salvar
        angular.copy(vm.attachmentEditing, vm.attachment); //Atualiza a model de anexo com um cópia do objeto que está sendo editado

        vm.attachment.isEditing = true;
      };

      vm.deleteAttachment = function (item, enumAttachmentType) {
        switch (enumAttachmentType) {
          case window.enumerators.attachmentType.InvoiceSale:
            vm.countAttachmentsInvoiceSale -= 1;
            break;
          default:
            break;
        }
        item.isDeleted = true;
        item.requiredDbUpdate = true;
      };

      vm.showAttachmentForm = function (visible, enumAttachmentType) {
        vm.isAttaching = visible;
        vm.attachType = enumAttachmentType;

        switch (enumAttachmentType) {
          case window.enumerators.attachmentType.InvoiceSale:
            vm.allowedFileExtensions = ["pdf", "jpeg", "png", "jpg"];
            vm.maxAllowedFileSize = parseInt(maxAllowedFileSize.value);
            break;
          default:
            break;
        }

        vm.attachment = {
          attachmentId: 0,
          attachmentTypeId: enumAttachmentType,
          isDeleted: false,
          isEditing: false,
          requiredDbUpdate: true,
        };

        // Reseta o formulário caso esteja fechando a modal de inclusão do anexo
        if (visible == false) vm.resetAttachmentForm();
      };

      vm.resetAttachmentForm = function () {
        var form = $scope.colorrequestAttachmentForm;
        form.$setPristine();
        form.$setUntouched();
      };

      vm.saveAttachment = function (enumAttachmentType) {
        $rootScope.laddaLoading = true;

        vm.attachment.requiredDbUpdate = true;

        // Verifica se é uma inclusão ou edição do objeto
        if (vm.attachment.isEditing == true) {
          angular.copy(vm.attachment, vm.attachmentEditing); // Repassa as atualizações feitas na model do anexo, para o objeto de referência (anexo que está sendo editado)
        } else {
          vm.attachments.push(vm.attachment); // Inclui o novo objeto no array

          switch (enumAttachmentType) {
            case window.enumerators.attachmentType.InvoiceSale:
              vm.countAttachmentsInvoiceSale += 1;
              vm.attachmentsInvoiceSale.push(vm.attachment);
              vm.addClassErrorInvoiceSale = false;
              break;
            default:
              break;
          }
        }

        vm.showAttachmentForm(false, 0);
        $rootScope.laddaLoading = false;
      };

      vm.uploadSubmit = function ($files, $event, $flow) {
        if ($files[0] === undefined) return;

        // Valida se a extensão do arquivo é permitida
        if (
          tools.validateFileExtension(
            $files[0].name,
            vm.allowedFileExtensions
          ) == false
        )
          return;

        // Valida o tamanho do arquivo
        if (
          tools.validateFileMaxSize($files[0].size, vm.maxAllowedFileSize) ==
          false
        )
          return;

        $flow.upload();
      };

      vm.uploadSuccess = function ($file, $message, $flow) {
        var uploadResult = JSON.parse($message);
        vm.attachment.name = uploadResult.originalFilename;
        vm.attachment.fileDocument = uploadResult.filename;
        vm.attachment.url = tools.getFileTempPath(
          vm.tempFolder,
          uploadResult.filename
        );

        // Reseta o flow
        $flow.cancel();
      };

      vm.getallowedFileExtensions = function (enumAttachmentType) {
        return "." + vm.allowedFileExtensions.join(", .");
      };

      vm.getFileExtension = function (filename) {
        return tools.getFileExtension(filename);
      };

      vm.selectCustomer = function () {
        if (!vm.model.customerId) {
          return;
        }

        ColorRequest.verifyCustomer(
          { customerId: vm.model.customerId },
          function (response) {
            // if (response.error60) {
            //     MessageService.alertInfo("Há projetos para esta loja com mais de 60 dias em aberto.");
            //     $state.go('main.colorrequest', {
            //         expired: true
            //     });
            //     return;
            // }

            if (response.error120) {
              MessageService.alertInfo(
                "Há projetos para esta loja com mais de 120 dias em aberto"
              );
              $state.go("main.colorrequest", {
                expired: true,
              });
              return;
            }

            // Se Loja Comercial e Bonificação for false devo verificar designer por uf.
            if (
              response.errorDesigner &&
              !vm.model.isBonusAccounts
            ) {
              MessageService.alertInfo(
                "Não há Designer para UF da loja selecionada."
              );
              $state.go("main.colorrequest");
              return;
            }

            vm.customerTypeIdSelected = response.customersTypeId;
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.isNewRequest = function () {
        return (
          vm.model.colorsRequestId === undefined ||
          vm.model.colorsRequestId == 0
        );
      };

      vm.isCompletedRequest = function() {
        return !vm.isNewRequest() && vm.model.status.isCompleted;
      }

      vm.getWorkflowApprovalParameter = function (enumStatusApproval) {
        return {
          colorsRequestId: vm.model.colorsRequestId,
          enumStatusApproval: enumStatusApproval,
          comment: vm.model.comment,
          disapprovalReasonId: vm.disapprovalReasonId
            ? vm.disapprovalReasonId
            : null,
        };
      };

      vm.save = function () {
        if (!vm.isNewRequest()) {
          return;
        }

        if (vm.selectedCustomer) {
          vm.model.customerId = vm.selectedCustomer.key
        }
        ColorRequest.insertExternal(vm.model).then(
          function (response) {
            $state.go('main.colorrequestexternal', { id: response });
          },
          function (response) {
            MessageService.alertError(response);
          }
        );
      }


      vm.changeStatus = function (nextStatus, commentRequired = false) {
        var message = "Deseja mesmo realizar a ação e mudar o status?";

        MessageService.confirm(
          function () {
            var params = vm.getWorkflowApprovalParameter(window.enumerators.statusApproval.Aprovado);

            WorkflowApproval.updateColor(
              params,
              function () {
                $state.go("main.colorrequest");
              },
              function (response) {
                MessageService.alertError(response.data);
              }
            );
          },
          "Confirmação",
          message
        );
      };

      vm.finishProject = function () {
        // Quando encerrar, se não houver venda, deve mandar para o status Concluído/Sem Venda, se tiver manda para Concluído/Venda.
        if (vm.salesListHasLength()) {
          vm.changeStatus("ConcluidoVenda");
        } else {
          vm.changeStatus("ConcluidoSemVenda");
        }
      };

      /*
      Funções de Sales
      */
      // #region Sales

      vm.noColorProductId = false;

      vm.insertSale = function () {
        if (
          vm.sale.valueOthersProducts == 0 &&
          vm.sale.valueTintingProducts == 0
        ) {
          MessageService.alertInfo(
            "Valor em produtos Tintométricos ou Valor em demais produtos deve ser preenchido."
          );
          return;
        }

        if (
          vm.attachmentsInvoiceSale.filter((x) => x.isDeleted == 0).length == 0
        ) {
          MessageService.alertInfo("Nota fiscal obrigatório");
          return;
        }
        vm.sale.tempFolder = vm.tempFolder;
        vm.sale.attachmentsInvoiceSale = vm.attachmentsInvoiceSale;
        vm.sale.colorsRequestId = vm.model.colorsRequestId;

        ColorRequest.insertSale(
          vm.sale,
          function (response) {
            vm.getAttachsAndSales();
            vm.cancelInsertSale();
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.cancelInsertSale = function () {
        vm.sale = {
          valueTintingProducts: 0,
          valueOthersProducts: 0,
          colorsProducts: [],
          othersProducts: [],
        };
        vm.attachmentsInvoiceSale = [];
        vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;
        vm.isInsertSale = false;
      };

      vm.getTintingProducts = function (val) {
        vm.autoCompleteProducts = Internal.colorsProductsList({ pageSize: 50, keyword: val })
          .$promise;
        return vm.autoCompleteProducts;
      };

      vm.getOthersProducts = function (val) {
        return Internal.othersProductsList({ pageSize: 50, keyword: val })
          .$promise;
      };

      $scope.$watch("vm.colorProduct", function (newValue, oldValue) {
        if (newValue) {
          var exist = false;
          vm.noColorProductId = false;

          if (!vm.sale.colorsProducts) {
            vm.sale.colorsProducts = [];
          }

          if (newValue.colorsProductId) {
            vm.sale.colorsProducts.map((x) => {
              if (newValue.colorsProductId == x.colorsProductId) {
                exist = true;
              }
            });
          } else {
            vm.noColorProductId = true;
          }

          if (!exist && newValue.colorsProductId) {
            vm.sale.colorsProducts.push(newValue);
            vm.colorProduct = null;
          }
        }
      });

      $scope.$watch("vm.salesProductColor", function (newValue, oldValue) {
        if (vm.colorProduct && newValue) {
          var exist = false;
          vm.noColorProductId = false;

          vm.colorProduct.colorId = newValue.colorId;
          vm.colorProduct.code = newValue.code;
          vm.colorProduct.colorName = newValue.name;
          vm.colorProduct.rgb = newValue.rgb;

          vm.colorProduct.description = `${vm.colorProduct.code}' '${vm.colorProduct.colorName} - ${vm.colorProduct.productName}`;

          if (!vm.sale.colorsProducts) {
            vm.sale.colorsProducts = [];
          }

          vm.sale.colorsProducts.map((x) => {
            if (vm.colorProduct.colorId == x.colorId && vm.colorProduct.productId == x.productId) {
              exist = true;
            }
          });

          if (!exist) {
            vm.sale.colorsProducts.push(vm.colorProduct);
          }

          vm.colorProduct = null;
          vm.salesProductColor = null;
        }
      });

      $scope.$watch("vm.otherProduct", function (newValue, oldValue) {
        if (newValue) {
          var exist = false;

          if (!vm.sale.othersProducts) {
            vm.sale.othersProducts = [];
          }
          vm.sale.othersProducts.map((x) => {
            if (newValue.othersProductId == x.othersProductId) {
              exist = true;
            }
          });

          if (!exist) {
            vm.sale.othersProducts.push(newValue);
          }

          vm.otherProduct = null;
        }
      });

      vm.delColorProduct = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.sale.colorsProducts.splice(index, 1);
      };

      vm.delOtherProduct = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.sale.othersProducts.splice(index, 1);
      };

      vm.editSale = function (saleId) {
        ColorRequest.saleGet(
          { saleId: saleId },
          function (response) {
            vm.sale = response;
            vm.isInsertSale = true;
            vm.attachmentsInvoiceSaleList.map((x) => {
              if (x.saleId == vm.sale.saleId) {
                vm.attachmentsInvoiceSale.push(x);
              }
            });
            vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.deleteSale = function (saleId) {
        MessageService.confirm(
          function () {
            ColorRequest.deleteSale(
              { saleId: saleId },
              function () {
                vm.getAttachsAndSales();
              },
              function (response) {
                MessageService.alertError(response.data);
              }
            );
          },
          "Confirmação",
          "Deseja mesmo excluir essa venda?"
        );
      };

      vm.getAttachsAndSales = function () {
        Attachment.list(
          { promotionRequestId: vm.model.colorsRequestId },
          function (response) {
            vm.attachmentsInvoiceSaleList =
              response.filter(
                (x) =>
                  x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
              ).length > 0
                ? response.filter(
                  (x) =>
                    x.attachmentTypeId ==
                    window.enumerators.attachmentType.InvoiceSale
                )[0].attachments
                : [];
            vm.getSales();
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.getSales = function () {
        ColorRequest.listSales(
          { colorsRequestId: vm.model.colorsRequestId },
          function (response) {
            vm.formSalesList(response);
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.formSalesList = function (response) {
        vm.salesList = response.saleList;
        const totalSale = {
          createdOn: "Valor total",
          valueTintingProducts: response.saleTotal.sumValueTintingProducts,
          valueOthersProducts: response.saleTotal.sumValueOthersProducts,
        };


        vm.salesList.push(totalSale);
        if (vm.salesList) {
          if (!vm.attachmentsInvoiceSaleList || !vm.attachmentsInvoiceSaleList.length) {
            vm.attachmentsInvoiceSaleList = [];
          }

          vm.salesList.map((x) => {
            const attach = vm.attachmentsInvoiceSaleList.find(
              (y) => y.saleId == x.saleId
            );
            if (attach) {
              x.url = attach.url;
              x.fileDocument = attach.fileDocument;
              x.attachmentId = attach.attachmentId,
                x.status = attach.enumStatusApproval;
            }
            return x;
          });

        }
      };

      vm.formSalesList(salesList);

      vm.salesListHasLength = function () {
        // Necessário para remover a última linha que exibe a soma de todas as notas.
        const onlySales = vm.salesList.filter((x) => x.saleId != null);
        if (onlySales.length == 0) {
          return false;
        }
        return true;
      };

      vm.showProjectAttachment = function () {
        if (vm.isNewRequest()) {
          return false;
        }

        return true;
      };

      // #ndregion Sales



      $scope.$watch("vm.selectedCustomer", function (newValue, oldValue) {
        if (newValue && newValue.key && (!oldValue || newValue.key !== oldValue.key)) {
          Customer.get(
            { id: newValue.key },
            function (response) {
              if (!response.hasColorSample) {
                if (response.hasColorSampleLastAskedOn && !(response.hasColorSampleLastAskedOn instanceof Date)) {
                  response.hasColorSampleLastAskedOn = new Date(response.hasColorSampleLastAskedOn);
                  if (isNaN(response.hasColorSampleLastAskedOn.getTime())) {
                    return;
                  }

                  response.hasColorSampleLastAskedOn.setMonth(response.hasColorSampleLastAskedOn.getMonth() + 1);
                }

                var currentDate = new Date();

                if (!response.hasColorSampleLastAskedOn || currentDate.getTime() >= response.hasColorSampleLastAskedOn.getTime()) {
                  MessageService.confirm(
                    function () {
                      var data = {
                        customerId: vm.selectedCustomer.key,
                        hasColorSample: true
                      }
                      Customer.updateHasColorSample(data);
                    },
                    "Amostra de cores",
                    "<img src='/images/color-sample.png' alt='Color Sample' /> Esta loja já possui a amostra de cores - A Sua Cor?"
                  );
                }
              }
            }
          );
        }
      });
    }
  );
